/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  margin-block-end: 1px;
  box-sizing: border-box;
  display: flex;
  background-color: var(--calcite-color-foreground-1);
  font-size: var(--calcite-font-size--1);
  color: var(--calcite-color-text-2);
  --tw-shadow: 0 1px 0 var(--calcite-color-border-3);
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition: background-color var(--calcite-animation-timing), box-shadow var(--calcite-animation-timing);
}
:host * {
  box-sizing: border-box;
}

calcite-pick-list-item {
  position: relative;
  margin: 0px;
  flex-grow: 1;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:host([active]),
:host([selected]) {
  --tw-shadow: 0 0 0 1px var(--calcite-color-brand);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.handle {
  display: flex;
  cursor: move;
  align-items: center;
  justify-content: center;
  border-style: none;
  background-color: transparent;
  padding-block: 0px;
  padding-inline: 0.25rem;
  color: var(--calcite-color-border-input);
  outline-color: transparent;
}
.handle:hover {
  background-color: var(--calcite-color-foreground-2);
  color: var(--calcite-color-text-1);
}
.handle:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.handle--activated {
  background-color: var(--calcite-color-foreground-3);
  color: var(--calcite-color-text-1);
}
.handle calcite-icon {
  color: inherit;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}